<template>
  <custom-dialog
    :title="model.title"
    :appendToBody="true"
    :visible="visible"
    width="600px"
    v-on="$listeners"
    class="pay-type-dialog"
  >
    <div
      class="dialog-body"
      style="padding-top :0 !important;"
    >
      <div class="tips">{{ $t('pay_type_dialog.qxzfkfs') }}</div>
      <div class="types">
        <div
          class="item"
          @click="onConfirm('account')"
        >
          <i class="icon icon-account tag"></i>
          <span class="label">{{ $t('pay_type_dialog.dui_gong_zhuan_zhang') }}</span>
        </div>
        <div
          class="item"
          @click="onConfirm('cash')"
        >
          <i class="icon icon-cash tag"></i>
          <span class="label">{{ $t('pay_type_dialog.xian_jin_zhi_fu') }}</span>
        </div>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';


export default {
  mixins: [dialogMixins],
  name: 'payTypeDialog',
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    onConfirm(type) {
      this.$emit('confirm', type);
      this.visible = false;
    }
  },
};
</script>

<style lang="scss">
.pay-type-dialog {
  .tips {
    color: #4d4d4d;
    font-size: 14px;
    line-height: 20px;
  }

  .types {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 44px;
    .item {
      background: #f8f8f8;
      box-shadow: 0 0 0 1px #f5f5f5 inset;
      border-radius: 8px;
      width: 264px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      cursor: pointer;

      .tag {
        font-size: 18px;
        color: #00a0d9;
      }
      .label {
        color: #202945;
        font-size: 16px;
        font-weight: bold;
        padding-left: 10px;
      }
    }
  }
}
</style>
